import { useEffect, useState } from 'react'
import { Button, Expandable } from 'components'
import Flex from 'components/priority/Flex/Flex'
import { CaseFormSection } from '..'
import { M3FamilyAppreciationMessage } from 'components/dashboard/CaseDetails/M3FamilyAppreciationMessage'
import { useTranslation } from 'react-i18next'
import { useIsM3Order } from '@/hooks/utility/useIsM3Order'

export const ServiceInfo = ({ saveCase, setActiveTab, activeTab }) => {
  const { t } = useTranslation()
  const [expandedServiceDetails, setExpandedServiceDetails] = useState(true)
  //const [expandedMusicSelections, setExpandedMusicSelections] = useState('')
  const [expandedPallbearers, setExpandedPallbearers] = useState('')
  const [expandedInterment, setExpandedInterment] = useState('')
  const [expandedAppreciation, setExpandedAppreciation] = useState(false)
  // The family appreciation message is an M3-only case field.
  const isM3Order = useIsM3Order()

  useEffect(() => {
    setExpandedServiceDetails(true)
    setExpandedPallbearers(false)
    //setExpandedMusicSelections(false)
    setExpandedInterment(false)
    setExpandedAppreciation(false)
  }, [activeTab])

  const saveAndContinue = (expanded) => {
    switch (expanded) {
      case 'serviceInfo':
        setExpandedServiceDetails(false)
        setExpandedPallbearers(true)
        break
      case 'musicSelections':
        setExpandedPallbearers(true)
        break
      case 'pallBearersSocieties':
        setExpandedInterment(true)
        setExpandedPallbearers(false)
        setExpandedServiceDetails(false)
        break
      case 'intermentInfo':
        setExpandedInterment(false)
        setExpandedPallbearers(false)
        setExpandedServiceDetails(false)
        if (isM3Order) {
          setExpandedAppreciation(true)
          break
        }
        setActiveTab(t('caseDetails.tabs.imagesAndFamilyMemorials.title'))
        break
      case 'familyAppreciation':
        setExpandedAppreciation(false)
        setActiveTab(t('caseDetails.tabs.imagesAndFamilyMemorials.title'))
        break
      default:
        //for now collapse all
        setExpandedInterment(false)
        setExpandedPallbearers(false)
        //setExpandedMusicSelections(false)
        setExpandedServiceDetails(false)
    }
    saveCase()
  }

  return (
    <Flex column full padding="0 48px 0 0">
      <Flex column align="flex-start">
        <Expandable
          margin="0 0 32px 0"
          title={t('caseDetails.tabs.serviceInfo.serviceDetails')}
          show={[expandedServiceDetails, setExpandedServiceDetails]}
          full
        >
          <CaseFormSection
            formSection="serviceInfo"
            saveAndContinue={saveAndContinue}
          />
        </Expandable>

        {/*     <Expandable
          margin="0 0 32px 0"
          title="Music selections"
          show={[expandedMusicSelections, setExpandedMusicSelections]}
          full
        >
          <CaseFormSection
            formSection="musicSelections"
            saveAndContinue={saveAndContinue}
          />
        </Expandable> */}
        <Expandable
          margin="0 0 32px 0"
          title={t('caseDetails.tabs.serviceInfo.pallbearers')}
          show={[expandedPallbearers, setExpandedPallbearers]}
          full
        >
          <CaseFormSection
            formSection="pallBearersSocieties"
            saveAndContinue={saveAndContinue}
          />
        </Expandable>
        <Expandable
          margin="0 0 32px 0"
          title={t('caseDetails.tabs.serviceInfo.intermentInformation')}
          show={[expandedInterment, setExpandedInterment]}
          full
        >
          <CaseFormSection
            formSection="intermentInfo"
            saveAndContinue={saveAndContinue}
          />
        </Expandable>
        {isM3Order && (
          <Expandable
            margin="0 0 32px 0"
            title={t('caseDetails.tabs.serviceInfo.familyAppreciation')}
            show={[expandedAppreciation, setExpandedAppreciation]}
            full
          >
            <M3FamilyAppreciationMessage margin="0 0 24px 0" />
            <Flex justify="flex-end">
              <Button
                primary
                onClick={() => saveAndContinue('familyAppreciation')}
              >
                {t('caseDetails.saveAndContinueButton')}
              </Button>
            </Flex>
          </Expandable>
        )}
      </Flex>
    </Flex>
  )
}

export default ServiceInfo
